// extracted by mini-css-extract-plugin
export default {"orderHeader":"Sponsors_orderHeader__4vtUU","button":"Sponsors_button__7NGy2"};